export const FILTER = "filters/filter";
export const SEARCHQUERY = "filters/searchQuery";
